import type {YamlTemplate} from '@github-ui/code-view-types'
import {VerifiedHTMLText} from '@github-ui/safe-html/VerifiedHTML'
import {AlertIcon} from '@primer/octicons-react'
/* eslint-disable-next-line primer-react/no-deprecated-flash -- Existing Flash usage should be migrated to Banner. */
import {Flash, Link} from '@primer/react'

import styles from './DiscussionTemplateBanner.module.css'

export function DiscussionTemplateBanner({errors}: YamlTemplate) {
  if (!errors || errors.length === 0) {
    return null
  }

  const errorMessageLinkText: string[] = []
  if (errors.length === 1) {
    errorMessageLinkText.push('Learn more about this error.')
  } else {
    errors.map((error, index) => {
      errorMessageLinkText.push(`Learn more about error ${index + 1}.`)
    })
  }

  return (
    <Flash variant={'danger'} className={styles.Flash}>
      <p>
        <AlertIcon />
        <strong>There {errors.length === 1 ? 'is a problem' : 'are some problems'} with this template</strong>
      </p>
      {errors.map((error, index) => {
        return (
          // eslint-disable-next-line @eslint-react/no-array-index-key
          <p key={`error-${index}`}>
            <VerifiedHTMLText html={error.message} />
            {'. '}
            <Link href={error.link} target="_blank">
              {errorMessageLinkText[index]}
            </Link>
          </p>
        )
      })}
    </Flash>
  )
}
